export default __webpack_public_path__ + "static/pragicts-digital-outreach-banner-agriculture-drones-ff8fd9fb2ea4cd5ff199bc9cd7499acd.jpg";